<template>
  <div
    class="blog-post-slider__single-slide blog-post-slider__single-slide--grid-view"
  >
    <div class="blog-post-slider__image section-space--bottom--30">
      <router-link :to="'/article/' + blog.slug">
        <img
          :src="$backendPublic + blog.image"
          class="img-fluid"
          :alt="blog.title"
        />
      </router-link>
    </div>
    <div class="blog-post-slider__content">
      <p class="post-date">{{ blog.date }}</p>
      <h3 class="post-title">
        <router-link :to="'/article/' + blog.slug">{{
          blog.title
        }}</router-link>
      </h3>
      <p class="post-excerpt" v-html="formattedSkimContent"></p>
      <router-link :to="'/article/' + blog.slug" class="see-more-link"
        >بیشتر</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["blog"],
  computed: {
    formattedSkimContent() {
      let size = 200
      let value = this.blog.content.replace(/<\/?[^>]+>/gi, " ")
      return `${value.slice(0, size).trim()}...`
    },
  },
}
</script>
